import { Component, OnInit } from '@angular/core';
import { Products } from 'src/app/model/products.model';
import { OrderService } from 'src/app/services/order/order.service';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-filledorder',
  templateUrl: './filledorder.component.html',
  styleUrls: ['./filledorder.component.css']
})
export class FilledorderComponent implements OnInit {

  data: any;
  isUserAdmin: boolean;
  isUserVendor: boolean;
  isUserHr: boolean;

  constructor(private orderServices: OrderService, private router: Router, private userService: UserService) {

    this.userService.isUserAdmin.subscribe(
      value => {
        this.isUserAdmin = value;
      });

    this.userService.isUserVendor.subscribe(
      value => {
        this.isUserVendor = value;
      });

    this.userService.isUserHr.subscribe(
      value => {
        this.isUserHr = value;
      });

  }

  ngOnInit() {
    if (this.isUserAdmin) {
      this.getAllFilledOrder();
    }
    if (this.isUserVendor) {
      this.getMyFilledOrder();
    }
    if (this.isUserHr) {
      this.getAllFilledOrder();
    }
  }

  getAllFilledOrder() {
    this.orderServices.getAllFilledOrder().subscribe(
      (data: any) => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  getMyFilledOrder() {
    this.orderServices.getMyFilledOrder().subscribe(
      (data: any) => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  ViewOrder(orderno: string) {
    if (orderno != null) {
      this.router.navigate(['/manageorder', orderno]);
    }
  }

}
